import { defHttp } from "../utils/http/axios";

const Api = {
    productInfo : '/sys/tenantEx/product/info',
    productCatList : '/sys/tenantEx/product/default/cat/list',
    catConfig : '/sys/tenantEx/product/cat/config',
    productCatConfigMerged : '/sys/tenantEx/product/cat/config/merged',

}

/**
 * 获取租户产品的相关信息
 * @param {productTypeCode,tenantId} data 
 * @returns 
 */
export  function getTenantProductInfo(data){
    return defHttp.post({url: Api.productInfo, data});
}

/**
 * 获取默认的CAT配置信息集合
 * @returns 
 */
export  function getDefaultCatConfigList(){
    return defHttp.get({url: Api.productCatList});
}

/**
 * 获取CAT产品配置信息
 * @param {*} params 
 * @returns 
 */
export  function getProductConfigCatVO(params){
    return defHttp.get({url: Api.catConfig, params});
}

/**
 * 获取CAT产品配置信息
 * @param {*} data 
 * @returns 
 */
export  function getProductConfigCatMerged(tenantId){   
    let params = {
        tenantId:tenantId
    }
    return defHttp.get({url: Api.productCatConfigMerged, params});
}

